import React, { PureComponent } from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Picture } from 'formlabs-web-components/Media';
import { Header } from 'formlabs-web-components/Type';
import { Link } from 'formlabs-web-components/Link';

import './Employee.module.css';

const Employee = DisplayComponent(
  class Employee extends PureComponent {
    render() {
      const { name, image, ctaUrl, department, classes } = this.props;
      return (
        <div className={classes} styleName="employee">
          <div styleName="image-limit">
            <Picture
              largeImage={image}
              imageStyles={{
                borderRadius: '200px',
                border: '5px solid #fff',
                marginBottom: '15px'
              }}
              lazyload={false}
            />
          </div>

          <div styleName="employee-copy">
            <Header level={6} displayAs={6}>
              {name}
            </Header>
            <p styleName="department">{department}</p>
            <p styleName="read-more">
              <Link to={ctaUrl} target="_blank">
                Read More <i className="fl-arrow-right" />
              </Link>
            </p>
          </div>
        </div>
      );
    }
  }
);

Employee.propTypes = {};

export default Employee;
